import { useState } from "react";
import { useTranslation } from "react-i18next";
import { moneyInput } from "./betSettings.js";

export function useAutoSettings() {
  const [rounds, setRounds] = useState("10");
  const [stopWin, setStopWin] = useState("");
  const [stopLoss, setStopLoss] = useState("");
  const count = Number(rounds);
  const valid =
    Number.isInteger(count) &&
    count > 0 &&
    count <= 1000 &&
    [stopWin, stopLoss].every((value) => value === "" || moneyInput(value)?.gt(0));
  return {
    rounds,
    setRounds,
    stopWin,
    setStopWin,
    stopLoss,
    setStopLoss,
    valid,
    settings: { rounds: count, stopWin, stopLoss },
  };
}

export function AutoBetControls({
  fields,
  running,
}: {
  fields: ReturnType<typeof useAutoSettings>;
  running: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="cx-auto-settings">
      <label className="cx-field">
        {t("auto.rounds")}
        <input
          className="cx-input"
          type="number"
          min={1}
          max={1000}
          step={1}
          value={fields.rounds}
          disabled={running}
          onChange={(event) => fields.setRounds(event.target.value)}
        />
      </label>
      <label className="cx-field">
        {t("auto.stopWin")}
        <input
          className="cx-input"
          inputMode="decimal"
          maxLength={25}
          value={fields.stopWin}
          disabled={running}
          placeholder={t("bet.autoCashoutOff")}
          onChange={(event) => fields.setStopWin(event.target.value)}
        />
      </label>
      <label className="cx-field">
        {t("auto.stopLoss")}
        <input
          className="cx-input"
          inputMode="decimal"
          maxLength={25}
          value={fields.stopLoss}
          disabled={running}
          placeholder={t("bet.autoCashoutOff")}
          onChange={(event) => fields.setStopLoss(event.target.value)}
        />
      </label>
    </div>
  );
}
